import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutData } from '@/mocks/tv-series';

export default function About() {
  const formSubmitAddr = 'https://readdy.ai/api/form/d9nfho8bdkpk99j7girg';

  return (
    <>
      <SEOHead
        title="关于我们 - 小草影院 | 品牌介绍与联系方式"
        description="小草影院成立于2018年，是国内领先的在线影视内容聚合平台。了解小草影院的品牌故事、发展历程、用户口碑及联系方式。"
        keywords="小草影院,关于小草影院,小草影院品牌介绍,小草影院联系方式,小草影院口碑"
        canonicalUrl="https://www.xiaocaoyingyuan.com/about"
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '小草影院首页', item: 'https://www.xiaocaoyingyuan.com/' },
            { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.xiaocaoyingyuan.com/about' },
          ],
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '小草影院',
          url: 'https://www.xiaocaoyingyuan.com/',
          description: '小草影院提供最新电视剧高清全集在线观看，热播剧集每日更新。',
          foundingDate: '2018',
          contactPoint: {
            '@type': 'ContactPoint',
            email: aboutData.contact.email,
            contactType: 'customer service',
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于小草影院',
          url: 'https://www.xiaocaoyingyuan.com/about',
          description: '了解小草影院的品牌故事、发展历程和联系方式。',
        }}
      />

      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-4">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />
      </div>

      <section className="relative w-full h-[350px] md:h-[450px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20home%20living%20room%20with%20a%20large%20TV%20screen%20showing%20a%20movie%2C%20comfortable%20sofa%20with%20blankets%2C%20soft%20warm%20lighting%2C%20evening%20atmosphere%2C%20cinematic%20shot%2C%20relaxing%20vibe%2C%20home%20entertainment%20scene&width=1920&height=600&seq=about-hero-2025&orientation=landscape"
          alt="小草影院品牌故事"
          title="小草影院 - 关于我们"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3">
            关于小草影院
          </h1>
          <p className="text-base md:text-lg text-white/70 max-w-xl">
            {aboutData.slogan}
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-12">
          {[
            { label: '成立时间', value: aboutData.founded },
            { label: '累计用户', value: aboutData.userCount },
            { label: '收录内容', value: aboutData.contentCount },
            { label: '每日更新', value: aboutData.dailyUpdate },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-4 rounded-lg bg-background-100 border border-background-200/70">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="max-w-3xl">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
            品牌介绍
          </h2>
          <p className="text-sm text-foreground-700 leading-relaxed mb-6">
            {aboutData.introduction}
          </p>
          <p className="text-sm text-foreground-700 leading-relaxed">
            {aboutData.story}
          </p>
        </div>
      </section>

      <section className="bg-background-100 py-10 md:py-14">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
            核心价值观
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {aboutData.values.map((v) => (
              <div key={v.title} className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-check-double-line text-lg"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                  {v.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          用户口碑
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {aboutData.testimonials.map((t, i) => (
            <div key={i} className="p-5 rounded-lg bg-background-100 border border-background-200/70">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }, (_, j) => (
                  <div key={j} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-xs ${j < Math.floor(t.rating) ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{t.comment}</p>
              <p className="text-xs text-foreground-500 font-medium">{t.user}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-background-100 py-10 md:py-14">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/2">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 mb-6">
                如有任何问题或建议，欢迎通过以下方式与我们取得联系。我们的客服团队将尽快回复您。
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">电子邮箱</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">微信公众号</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.wechat}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-weibo-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">新浪微博</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.weibo}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">公司地址</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.address}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-1/2">
              <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">
                  发送消息
                </h3>
                <form
                  id="about-contact-form"
                  data-readdy-form=""
                  className="flex flex-col gap-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const fd = new FormData(form);

                    const honeypotVal = (fd.get('phone_alt') as string || '').trim();
                    if (honeypotVal) {
                      const successMsg = document.getElementById('about-form-success');
                      if (successMsg) successMsg.style.display = 'block';
                      form.reset();
                      return;
                    }
                    fd.delete('phone_alt');

                    try {
                      const formUrl = formSubmitAddr;
                      const response = await fetch(formUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
                      });
                      const responseText = await response.text();
                      let parsed;
                      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                      if (response.ok && parsed?.code === 'OK') {
                        const el = document.getElementById('about-form-success');
                        if (el) el.style.display = 'block';
                        const errEl = document.getElementById('about-form-error');
                        if (errEl) errEl.style.display = 'none';
                        form.reset();
                      } else {
                        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
                        const errEl = document.getElementById('about-form-error');
                        if (errEl) {
                          errEl.textContent = typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试';
                          errEl.style.display = 'block';
                        }
                      }
                    } catch {
                      const errEl = document.getElementById('about-form-error');
                      if (errEl) {
                        errEl.textContent = '网络错误，请稍后重试';
                        errEl.style.display = 'block';
                      }
                    }
                  }}
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="您的姓名"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all"
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的消息..."
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all resize-none"
                  ></textarea>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="form-anti-spam"
                  />
                  <button
                    type="submit"
                    className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    发送消息
                  </button>
                  <p
                    id="about-form-success"
                    className="text-sm text-accent-600 font-medium hidden"
                  >
                    消息已发送成功，我们会尽快回复您！
                  </p>
                  <p
                    id="about-form-error"
                    className="text-sm text-red-500 font-medium hidden"
                  ></p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}